// extracted by mini-css-extract-plugin
export default {"no-scroll-button":"_2KoTo","noScrollButton":"_2KoTo"};